import { useState, useEffect } from "react";
import Header from "../../component/menu/Header";
import { constants } from "../../constant/constants";
import SideMenu from "../../component/menu/SideMenu";
import useUserStore from "../../stores/store";
import CustomLoader from "../../component/menu/CustomLoader";
import { ConfigProvider, Select, Pagination, Input, Image } from "antd";
import ReportTable from "../../component/restaurants/reports/ReportTable";
import { PAGINATION_PAGE_OPTIONS, TABLE_AND_STAFF_LIST_CONTEXT } from "../../constant/constants";
import ApiService from "../../utils/ApiService";
import ConfirmModal from "../../component/modals/ConfirmModal";
import { useNavigate, useLocation } from "react-router-dom";
import { preparePlaceDropdown, prepareTableAndStaffList } from "../../services/table-management/waiter.service";


export default function WaiterList() {
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const paramRestaurantId = searchParams.get("restaurantId");
    const paramBranchId = searchParams.get('branchId');

    const { user, restaurantId, showNotification, networkCall, setNetworkCall, isSuperAdmin } = useUserStore();
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [totalItem, setTotalItem] = useState(0);
    const [listFilter, setListFilter] = useState({
        restaurantId: restaurantId || paramBranchId,
        context: TABLE_AND_STAFF_LIST_CONTEXT.WAITER_LIST,
        searchKey: "",
        floorId: "",
    });

    const [placeDropdown, setPlaceDropdown] = useState([]);
    const [tableStaffList, setTableStaffList] = useState([]);
    const [openDelModal, setOpenDelModal] = useState(false);

    const [dependencyObj, setDependencyObj] = useState({});
    const [currentUnassignId, setCurrentUnassignId] = useState("");


    async function getFloorDropdowns(params) {
        setNetworkCall(true);
        if (!params) return;
        if (!params.hasOwnProperty("restaurantId")) {
            console.error("restaurantId is required for getting floor dropdown.");
            return;
        }
        try {
            const res = await ApiService.GET_TABLEMANAGEMENT_FLOOR_DROPDOWN(params, user.token.token);
            if (res.code !== 200) {
                showNotification(res.data.message);
                setNetworkCall(false);
                return;
            }
            const { payload } = res;
            const { records } = payload;

            setPlaceDropdown(preparePlaceDropdown(records));
            setNetworkCall(false);
        } catch (err) {
            setNetworkCall(false);
            showNotification(err.response.data.message);
            return;
        }
    }


    async function fetchTableAndStaffList(params) {
        setNetworkCall(true);
        if (!params) return;
        if (!params.hasOwnProperty("restaurantId")) {
            console.error("restaurantId is required for getting floor and staff list.");
            return;
        } if (!params.hasOwnProperty('context')) {
            console.error("context is required for getting floor and staff list.");
            return;
        }
        try {
            const res = await ApiService.GET_TABLE_AND_STAFF_LIST(params, user.token.token);
            if (res.code !== 200) {
                showNotification(res.message);
                setNetworkCall(false);
                return;
            }
            const { payload } = res;
            const { records, page, perPage, total } = payload;

            setPage(page);
            setPerPage(perPage);
            setTotalItem(total);
            setTableStaffList(records);
            setNetworkCall(false);
        } catch (err) {
            console.log('---err----', err);
            setNetworkCall(false);
            showNotification(err.response.message);
            return;
        }
    }

    function onHandleSearchKey(e) {
        setListFilter(prev => ({
            ...prev,
            searchKey: e.target.value
        }))
    }

    function onHandleFloorSelect(value) {
        setListFilter(prev => ({
            ...prev,
            floorId: value
        }))
    }

    function onHandlePageChange(page, pageSize) {
        setPage(page);
        setPerPage(pageSize);
        const params = {
            ...listFilter,
            page: page,
            perPage: pageSize
        };
        fetchTableAndStaffList(params);
    }

    function onHandleClearFilter() {
        setPage(1);
        setPerPage(10);
        setListFilter(prev => ({
            ...prev,
            searchKey: "",
            floorId: ""
        }));
        fetchTableAndStaffList({ restaurantId: listFilter.restaurantId, context: listFilter.context });
    }

    function onHandleSearch() {
        const params = {
            ...listFilter,
            page: page,
            perPage: perPage
        };

        fetchTableAndStaffList(params);
    }

    async function unassignTableStaff(params) {
        setNetworkCall(true);
        try {
            const res = await ApiService.TABLEMANAGEMENT_TABLE_AND_STAFF_UNASSIGN(params, user.token.token);
            if (res.code !== 200) {
                setOpenDelModal(false);
                setNetworkCall(false);
                showNotification(res.message);
                setCurrentUnassignId("");
                return;
            }

            setOpenDelModal(false);
            setNetworkCall(false);
            fetchTableAndStaffList({ restaurantId: listFilter.restaurantId, context: listFilter.context });
            showNotification("The waiter is successfully unassign from the table", false);
            return;
        } catch (err) {
            setOpenDelModal(false);
            setNetworkCall(false);
            showNotification(err.response.message);
            return;
        }
    }

    function onHandleDelete(id) {
        setCurrentUnassignId(id);
        setOpenDelModal(true);
    }

    function onHandleOk() {
        const itemObj = tableStaffList.find(item => item.id === currentUnassignId);
        if (!Boolean(itemObj?.staff?.staffId)) {
            setCurrentUnassignId("");
            setOpenDelModal(false);
            showNotification("No Staff to unassign from the table and floor!");
            return;
        }
        const resId = restaurantId || paramBranchId;
        const unassignPayload = {
            restaurantId: resId,
            floorId: itemObj?.floor?.id || "",
            tableId: itemObj.id,
            staffId: itemObj?.staff?.staffId || ""
        };
        unassignTableStaff(unassignPayload);
        setOpenDelModal(false);
        setCurrentUnassignId("");
    }

    function onHandleCancelFloorDel() {
        setOpenDelModal(false);
        setCurrentUnassignId("");
    }

    function onHandleAddWaiter() {
        let url = '/waiter/assign';
        const resId = restaurantId || paramRestaurantId;
        if (isSuperAdmin) {
            url += `?restaurantId=${resId}&branchId=${paramBranchId}`;
        }
        return navigate(url);
    }

    function onHandleBack() {
        let url = '/table';
        if (isSuperAdmin) {
            url = `/restaurants/${paramRestaurantId}/branch/${paramBranchId}/floor-plan`;
        }
        return navigate(url);
    }

    /** init */
    useEffect(() => {
        const resId = restaurantId || paramBranchId;
        async function fetchData() {
            if (resId) {
                await getFloorDropdowns({ restaurantId: resId });
                await fetchTableAndStaffList({ restaurantId: listFilter.restaurantId, context: listFilter.context });
            }
        }
        fetchData();
    }, [restaurantId, paramBranchId]);

    return (
        <section>
            <div className="flex flex-col">
                <CustomLoader />
                <Header title={""} menu={constants.MENU.TABLE} currentMenuKey={'T_8_S_8'} />
                <div className="flex flex-row bg-prewhite px-[12%]">
                    <SideMenu title={`Waiter List`} menu={constants.MENU.TABLE} />
                </div>
                <div className=" mt-[80px] ml-[80px] px-[50px]">
                    <div className="pt-[50px] pb-[20px] flex items-center justify-between">
                        <h1 className="font-bold text-black text-[24px] leading-[24px] cursor-default">
                            Waiter List
                        </h1>
                        <div className="w-[100px] h-[40px]">
                            <button
                                className="w-full h-full bg-[#FFD700] text-[14px] font-bold leading-[16px] text-black rounded-[5px]"
                                onClick={onHandleBack}
                            >
                                Back
                            </button>
                        </div>
                    </div>

                    <section>
                        {/* filters */}
                        <ConfigProvider
                            theme={{
                                components: {
                                    Select: {
                                        zIndexPopup: 1,
                                    },
                                },
                            }}
                        >
                            <div className="flex items-center space-between w-full mt-[20px] mb-[31px]">
                                <div className="flex items-center space-x-[15px] items-center w-full">
                                    <div className="h-[48px] w-[20%]">
                                        <Input
                                            className="h-full w-full"
                                            value={listFilter.searchKey}
                                            onChange={onHandleSearchKey}
                                            placeholder="Search Keywords"
                                        />
                                    </div>
                                    <div className="h-[48px] w-[24.285714286%]">
                                        <Select
                                            className="w-full h-full"
                                            showSearch={true}
                                            onChange={onHandleFloorSelect}
                                            placeholder="Select Place"
                                            optionFilterProp="label"
                                            options={placeDropdown}
                                            value={listFilter.floorId === "" ? null : listFilter.floorId}
                                        />
                                    </div>
                                    <div className="h-[48px] w-[220px] flex items-center space-x-[15px]">
                                        <button
                                            className="w-full h-full bg-black text-[14px] font-bold leading-[16px] text-white rounded-[5px]"
                                            onClick={onHandleClearFilter}
                                        >
                                            Clear
                                        </button>
                                        <button
                                            className="w-full h-full bg-[#FCBD10] text-[14px] font-bold leading-[16px] text-black rounded-[5px]"
                                            onClick={onHandleSearch}
                                        >
                                            Search
                                        </button>
                                    </div>
                                </div>
                                <div className="h-[48px] w-[120px] flex items-center space-x-[20px]">
                                    <button
                                        onClick={onHandleAddWaiter}
                                        className="w-full h-full bg-[#2EC114] text-[14px] font-bold leading-[16px] text-white rounded-[5px] flex items-center space-x-2 justify-center">
                                        <p>Add</p>
                                        <Image src={'/images/icons/add-white.svg'} alt={"plus"} preview={false} />
                                    </button>
                                </div>
                            </div>
                        </ConfigProvider>

                        {/* sales report table */}
                        <div>
                            <div className="min-h-[50vh]">
                                <ReportTable
                                    isLoading={networkCall}
                                    data={prepareTableAndStaffList(tableStaffList)}
                                    context={"waiter-list"}
                                    page={page}
                                    perPage={perPage}
                                    actions={["delete"]}
                                    handleDelete={onHandleDelete}
                                />
                            </div>
                            <div className="mt-[20px] mb-[50px] report-pagination relative custom-pagination-options">
                                <Pagination
                                    showSizeChanger
                                    onChange={onHandlePageChange}
                                    onShowSizeChange={(current, size) => {
                                        setPerPage(size);
                                    }}
                                    current={page}
                                    pageSize={perPage}
                                    total={totalItem}
                                    pageSizeOptions={PAGINATION_PAGE_OPTIONS}
                                    locale={{ items_per_page: "" }}
                                    showQuickJumper={false}
                                />

                                <div
                                    className="absolute h-[48px] flex items-center space-x-[40px] 
          top-0 right-[122px] text-[18px] font-medium text-[#7D7D7D] mr-3"
                                >
                                    <div>Total: {totalItem}</div>
                                    <div>Row </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>

            {
                <ConfirmModal
                    isModalOpen={openDelModal}
                    records={{
                        title: "Confirm Please",
                        message: "Are you sure want to unassign the staff from the table?",
                        handleOk: onHandleOk,
                        handleCancel: onHandleCancelFloorDel,
                        confirmText: 'Ok',
                        cancelconfirmText: 'Cancel'
                    }}
                    showCancel={true}
                />
            }
            {/* floor delete dependency model */}
            {/* {dependencyObj?.dependentOrders?.length > 0 && (
                    <DependencyModal
                        open={openDelDependencyModal}
                        title="This recipe has some dependencies listed below. Are you sure want to delete it?"
                        dependentFoods={dependencyObj.dependentFoods}
                        dependentSetMenus={dependencyObj.dependentSetMenus}
                        dependentOrders={dependencyObj.dependentOrders}
                        handleConfirm={onHandleDeleteConfirmWithDependency}
                        handleCancel={() => setOpenDelDependencyModal(false)}
                    />
                )} */}
        </section>
    );
}
